import React, { useState } from "react";
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Typography,
  useTheme,
  alpha,
  Link,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Login from "./Login";

const StyledPaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(8),
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  background: alpha(theme.palette.background.paper, 0.9),
  backdropFilter: "blur(10px)",
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[10],
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.primary.main,
    height: 3,
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "1rem",
  minWidth: 120,
}));

const LandingPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const theme = useTheme();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="sm">
        <StyledPaper elevation={3}>
          <Typography
            component="h1"
            variant="h4"
            sx={{
              mb: 4,
              fontWeight: 700,
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            Welcome to Employee Portal
          </Typography>

          <StyledTabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="fullWidth"
            aria-label="login tabs"
          >
            <StyledTab label="Employee" />
            <StyledTab label="Employer" />
          </StyledTabs>

          <Login role={selectedTab === 0 ? "EMPLOYEE" : "EMPLOYER"} />
        </StyledPaper>
      </Container>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          py: 2,
          textAlign: "center",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Powered by{" "}
          <Link
            href="https://scstechservices.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "primary.main",
              textDecoration: "none",
              fontWeight: 600,
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            SCS Tech Services
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default LandingPage;
